// extracted by mini-css-extract-plugin
export default {"title":"style_title__TPFIT","rateCard":"style_rateCard__NqcPH","rateDate":"style_rateDate__6UPKw"};